import { Beacon } from "../../api/models";
import { useSetting } from "../../util";
import {
  BeaconTelemetryFilter,
  BeaconTelemetryFilterValue,
} from "../BeaconTelemetryFilter";
import {
  TimeRangeSelection,
  useTimeRangeSelection,
} from "../TimeRangeSelection";
import { AboutCard } from "../cards/about/AboutCard";
import { BeaconAccelerometerCard } from "../cards/accel/AccelerometerCard";
import { BeaconAlertCard } from "../cards/alert/AlertCard";
import { BeaconBatteryCard } from "../cards/battery/BeaconBatteryCard";
import { BeaconEventCard } from "../cards/event/EventCard";
import { BeaconLocationCard } from "../cards/location/LocationCard";
import { BeaconMapCard } from "../cards/map/MapCard";
import { BeaconPositionCard } from "../cards/position/PositionCard";

interface BeaconProps {
  constructionProjectId?: string;
  beacon: Beacon;
  breadcrumb: React.ReactElement;
}

export function BeaconDetails({ beacon, breadcrumb }: BeaconProps) {
  const [filter, setFilter] = useSetting<BeaconTelemetryFilterValue>(
    "beacon:telemetry-filter",
    "ShowAll"
  );

  const {
    selectedFromToFilter,
    fromToFilterOptions,
    selectedFromToFilterOptionIndex,
    onSelectFilterOption,
    onSelectCustomTimeFrame,
  } = useTimeRangeSelection(beacon.serial);

  return (
    <div className="screen-with-breadcrumb">
      <div className="screen-with-filter-header">
        <div style={{ justifySelf: "start" }}>{breadcrumb}</div>
        <div style={{ justifySelf: "center" }}>
          <TimeRangeSelection
            fromToFilterOptions={fromToFilterOptions}
            selectedFromToFilterOptionIndex={selectedFromToFilterOptionIndex}
            onSelectFilterOption={onSelectFilterOption}
            onSelectCustomTimeFrame={onSelectCustomTimeFrame}
          />
        </div>
        <div style={{ justifySelf: "end", marginLeft: "1rem" }}>
          <BeaconTelemetryFilter filter={filter} onFilterChanged={setFilter} />
        </div>
      </div>
      <div className="card-container-overflow-content">
        <AboutCard beacon={beacon} />
        <BeaconMapCard
          beacon={beacon}
          selectedFromToFilter={selectedFromToFilter}
          filter={filter}
        />
        <BeaconAlertCard
          serial={beacon.serial}
          selectedFromToFilter={selectedFromToFilter}
        />
        <BeaconEventCard
          beaconSerial={beacon.serial}
          selectedFromToFilter={selectedFromToFilter}
        />
        <BeaconLocationCard
          selectedFromToFilter={selectedFromToFilter}
          filter={filter}
          beaconSerial={beacon.serial}
        />
        <BeaconBatteryCard
          beaconSerial={beacon.serial}
          selectedFromToFilter={selectedFromToFilter}
        />
        <BeaconAccelerometerCard
          serial={beacon.serial}
          selectedFromToFilter={selectedFromToFilter}
        />
        <BeaconPositionCard
          serial={beacon.serial}
          selectedFromToFilter={selectedFromToFilter}
        />
      </div>
    </div>
  );
}
